import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import Vuetify, {
//   VApp, // required
//   VAppBar,
//   VLayout,
//   VCard,
//   VNavigationDrawer,
//   VFooter,
//   VItemGroup,
//   VItem,
//   VProgressLinear,
//   VSlider,
//   VSlideGroup,
//   VScaleTransition,
//   VToolbar,
//   VTooltip,
//   VTabs,
//   VTab,
//   VBtn,
//   VDataTable,
//   VRow,
//   // transitions,
// } from 'vuetify/lib';
// import transitions from 'vuetify/es5/components/transitions';
// import { Ripple } from 'vuetify/lib/directives';
// import '../assets/stylesheets/app.sass';
Vue.use(Vuetify);

const vuetifyOpts = {
  // components: {
  //   VApp,
  //   VAppBar,
  //   VLayout,
  //   VCard,
  //   VNavigationDrawer,
  //   VFooter,
  //   VItemGroup,
  //   VItem,
  //   VProgressLinear,
  //   VSlider,
  //   VSlideGroup,
  //   VScaleTransition,
  //   VToolbar,
  //   VTooltip,
  //   VBtn,
  //   VDataTable,
  //   VRow,
  //   VTabs,
  //   VTab,
  //   transitions,
  // },
  // directives: {
  //   Ripple,
  // },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#577189',
        accent: '#577189',
      },
    },
  },
};

export default new Vuetify(vuetifyOpts);
